import { render, staticRenderFns } from "./ns-popup.vue?vue&type=template&id=1786d25e&scoped=true&"
import script from "./ns-popup.vue?vue&type=script&lang=js&"
export * from "./ns-popup.vue?vue&type=script&lang=js&"
import style0 from "./ns-popup.vue?vue&type=style&index=0&id=1786d25e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1786d25e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1786d25e')) {
      api.createRecord('1786d25e', component.options)
    } else {
      api.reload('1786d25e', component.options)
    }
    module.hot.accept("./ns-popup.vue?vue&type=template&id=1786d25e&scoped=true&", function () {
      api.rerender('1786d25e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/loyalty-elements/src/common/ns-popup.vue"
export default component.exports